import { Bar } from "react-chartjs-2";
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, plugins} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarGraph = ({data,title}) => {
    
const numMonths = data.length;
const barPercentage = numMonths > 8 ? 0.8 : numMonths > 4 ? 0.7 : 0.4;
const categoryPercentage = numMonths > 8 ? 0.8 : numMonths > 4 ? 0.7 : 0.4;

    const chartData = {
        labels: data.length > 0 ? data.map(item => item.month) : [],
        datasets: [
            {
                label: '',
                data: data.length > 0 ? data.map(item => item.count) : [],
                backgroundColor: '#1b8593',
            }
        ]
    }

    const options = {
        responsive:true,
        maintainAspectRatio:true,
        plugins:{
            title:{
                display:true,
                text:title,
            },
        legend: {
            display: false // Hides the color representation (legend)
        }
        },
        scales:{
            y:{
                beginAtZero:true,
                title:{
                    display:true,
                    text:''
                },
            },
            x:{
                title:{
                    display:true,
                    text:''
                },
            }
        },
        // Add these lines to reduce bar width
        barPercentage: barPercentage, // default is 0.9, lower is thinner
        categoryPercentage: categoryPercentage // default is 0.8, lower is thinner
        
    }

    return (
    <div className="" style={{ width: '90%', height: 'auto' }}> 
    <Bar  data={chartData} options={options} />
    </div>
)
}

export default BarGraph;